export default "__VITE_PUBLIC_ASSET__14f41375__"